import { render, staticRenderFns } from "./PlayerResourceLogItems.vue?vue&type=template&id=4441acd0&scoped=true&"
import script from "./PlayerResourceLogItems.vue?vue&type=script&lang=js&"
export * from "./PlayerResourceLogItems.vue?vue&type=script&lang=js&"
import style0 from "./PlayerResourceLogItems.vue?vue&type=style&index=0&id=4441acd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4441acd0",
  null
  
)

export default component.exports